<template>
    <div>
        <header-fixed></header-fixed>
        <div class="main-top"> 
            <div id="main-content-area" class="container">
                <div class="row no-gutters">
                    <div id="main-content" class="col-lg-9 col-xl-9 order-lg-12">
                        <div id="salon-container" class="container">
                            <div class="row">
                                <div class="col-12">
                                    <div class="tab-content">
                                        <!--
                                        <div class="tab-pane fade show active" id="user-rezervacije" role="tabpanel">
                                            <reservation></reservation>
                                        </div>
                                        -->
                                        <div class="tab-pane fade show active" id="user-omiljeni" role="tabpanel"> 
                                            <favorites></favorites>
                                        </div>
                                        <div class="tab-pane fade" id="user-komentari" role="tabpanel">
                                            <comment></comment>
                                        </div>
                                        <div class="tab-pane fade" id="user-promo" role="tabpanel">
                                            <div class="container">
                                                <div class="row no-gutters">
                                                    <div class="col-12">
                                                        <div class="user-panel-title">
                                                            <h4>Promo bodovi</h4>
                                                        </div>
                                                        <p>Trenutno nemate promo bodove.</p>
                                                    </div>
                                                    <div class="col-12">

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade" id="user-postavke" role="tabpanel">
                                            <profile></profile>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div id="side-content" class="col-lg-3 col-xl-3 pb-5 order-lg-1 d-none d-lg-block">
                        <div class="salon-container container stickey-top">

                            <div class="nav navbar-nav user-menu-vert" role="tablist">

                                <!-- <a class="nav-item nav-link active" data-toggle="pill" id="Mojerezervacije" href="#user-rezervacije" role="tab"><span class="far fa-calendar-check fa-fw"></span>Moje rezervacije</a> -->
                                <a class="nav-item nav-link" data-toggle="pill" id="Omiljenisalon" href="#user-omiljeni" role="tab"><span class="far fa-heart fa-fw"></span>Omiljeni saloni</a>
                                <a class="nav-item nav-link" data-toggle="pill" id="Mojikomentari" href="#user-komentari" role="tab"><span class="far fa-comments fa-fw"></span>Moji komentari</a>
                                <!-- <a class="nav-item nav-link" data-toggle="pill" id="userpromo" href="#user-promo" role="tab"><span class="fas fa-tags fa-fw"></span>Promo bodovi</a> -->
                                <a class="nav-item nav-link" data-toggle="pill" id="postavke" href="#user-postavke" role="tab"><span class="fas fa-cog fa-fw"></span>Postavke profila</a>

                            </div>


                        </div>

                    </div>
                </div>

            </div>
        </div>
        <home-footer></home-footer>
    </div>
</template>

<script>
import profile from './profile';
// import reservation from './reservation';
import comment from './comment';
import favorites from './favorites';


export default {
    name:'user_dashboard', 
    components:{
        profile,
        // reservation,
        comment,
        favorites
    },
    mounted(){
        var hash=this.$route.hash.replace('#','');
        console.log(hash);
        if(hash != ''){
            document.getElementById(hash).click();
        }
    },
}
</script>